// Embed — escala única de breakpoints (PLAN §1.11 / §2.5).
//
// Antes el inline cambiaba a móvil en 760px y el overlay en 900px
// (con un 880 hermano en shell.ts): las tablets caían en tierra de
// nadie con dos layouts distintos según el modo. Ahora ambos modos
// interpolan estas constantes en sus template literals de CSS.
//
//   sm 560 — teléfono. Ajustes finos: bottom sheets, tap targets,
//            tipografía compacta.
//   md 850 — el corte de layout: una columna, galería bajo el canvas,
//            CTA sticky. Por debajo de md la experiencia es "móvil".
//   lg 1100 — desktop ancho: sidebar del overlay a tamaño completo.
//
// Las media queries puntuales por debajo de sm (480/440/420) son
// micro-ajustes de componentes concretos y se quedan hardcodeadas.

export const BP_SM = 560;
export const BP_MD = 850;
export const BP_LG = 1100;
